import { render, staticRenderFns } from "./StatisticProjectReportsTableItem.vue?vue&type=template&id=5f4d4f6a&scoped=true&"
import script from "./StatisticProjectReportsTableItem.vue?vue&type=script&lang=js&"
export * from "./StatisticProjectReportsTableItem.vue?vue&type=script&lang=js&"
import style0 from "./StatisticProjectReportsTableItem.vue?vue&type=style&index=0&id=5f4d4f6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4d4f6a",
  null
  
)

export default component.exports